var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-spinner",style:({height: (_vm.height + "vh")})},[_c('i',{staticClass:"la la-circle-notch"}),_c('span',[_vm._v("Loading "+_vm._s(_vm.title)+"...")])])}
var staticRenderFns = []

export { render, staticRenderFns }